<template>
  <div class="" testek="product-detail">
    <div class="header"></div>
    <BaseDetail
      @viewDetail="viewDetail"
      @addData="addData"
      @addMoreData="addMoreData"
      :currentItem="currentItem"
      :titleDetail="$t('i18nCommon.TitleCategoryId')"
    >
      <template #header>
        <div class="font-bold text-xl mb-4">{{ title }}</div>
      </template>
      <template #content>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              label-width="120px"
              class="demo-ruleForm"
              label-position="left"
              :size="formSize"
              status-icon
            >
              <a-form-item
                prop="Id"
                testek="Id"
                class="columns-1 w-full"
                v-if="mode == $enum.Mode.Edit"
              >
                <div class="flex w-full">
                  <div class="flex min-w-32 font-bold">
                    ID
                    <span class="ml-1 text-red-700">*</span>
                  </div>
                  <a-input v-model:value="ruleForm.id" />
                </div>
              </a-form-item>
              <div class="flex columns-2">
                <a-form-item
                  prop="categoryName"
                  testek="categoryName"
                  class="w-full mr-8"
                >
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Name") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.categoryName" />
                  </div>
                </a-form-item>
                <a-form-item class="w-full" prop="status" testek="status">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Status") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <h-combobox
                      :data="statuses"
                      :display="'status'"
                      :keyValue="'id'"
                      @change="onChangeStatus"
                      :value="ruleForm.status"
                      testek="status-combobox"
                      :placeholder="$t('i18nCommon.Status')"
                    ></h-combobox>
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="cateDesc" testek="cateDesc" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Description") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-textarea v-model:value="ruleForm.cateDesc" class="w-full" />
                  </div>
                </a-form-item>
              </div>
              <a-form-item class="mt-6">
                <div class="flex">
                  <a-button
                    type="primary"
                    testek="btn-add"
                    @click="submitForm()"
                    class="mr-4"
                  >
                    {{ $t("i18nCommon.Add") }}
                  </a-button>
                  <a-button type="primary" testek="btn-add-more" @click="addMoreData()">
                    {{ $t("i18nCommon.AddMore") }}
                  </a-button>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </template>
    </BaseDetail>
    <div v-if="isShow && category">
      <a-modal v-model:open="isShow" :closable="false" centered :width="800">
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-2xl">
            {{ $t("i18nCommon.TitleDetailInfo") }}
          </div>
          <div
            class="text-white h-9 w-36 bg-slate-900 rounded-lg flex justify-center items-center"
          >
            {{ $t("i18nCommon.Category") }}
          </div>
        </div>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              label-width="120px"
              class="demo-ruleForm"
              label-position="left"
              :size="formSize"
              status-icon
            >
              <div class="flex columns-2">
                <a-form-item prop="name" testek="name" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Name") }}
                    </div>
                    <a-input v-model:value="category.categoryName" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item class="w-full" prop="status" testek="status">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Status") }}
                    </div>
                    <a-input v-model:value="category.status" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="description" testek="description" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Description") }}
                    </div>
                    <a-input
                      v-model:value="category.cateDesc"
                      class="w-full"
                      :disabled="true"
                    />
                  </div>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="isShow = false">{{
            $t("i18nCommon.Close")
          }}</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { ModuleCategory } from "@/store/module-const";
import BaseDetail from "@/views/base/BaseDetail.vue";
import { mapActions } from "vuex";
import _ from "lodash";
export default {
  name: "CategoryDetail",
  components: {
    BaseDetail,
  },
  props: {},
  computed: {
    title() {
      if (this.mode == this.$enum.Mode.Edit) return this.$t("i18nCommon.EditCategory");
      return this.$t("i18nCommon.AddCategory");
    },
  },
  data() {
    return {
      ruleForm: {},
      rules: {},
      suppliers: [],
      categories: [],
      statuses: [],
      currentItem: {},
      category: {},
      isShow: false,
      mode: this.$enum.Mode.Add,
    };
  },
  created() {
    const me = this;
    me.initDataStatic();
    me.$emitter.on("LoadEditCategory", me.loadDataEdit);
  },
  beforeDestroy() {
    const me = this;
    me.$emitter.on("LoadEditCategory", me.loadDataEdit);
  },
  methods: {
    ...mapActions(ModuleCategory, ["createCategory", "getCategory", "updateCategory"]),
    initDataStatic() {
      const me = this;
      me.rules = {
        categoryName: [
          {
            required: true,
            message: `${me.$t("i18nProduct.CategoryNameInvalid")}`,
            trigger: "blur",
          },
        ],
        cateDesc: [
          {
            required: true,
            message: `${me.$t("i18nProduct.CategoryDescriptionInvalid")}`,
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: `${me.$t("i18nProduct.StatusInvalid")}`,
            trigger: ["change", "blur"],
          },
        ],
      };
      me.statuses = this.$config.StatusInfos;
    },
    loadDataEdit: _.debounce(async function (payload) {
      const me = this;
      if (!payload) return;
      me.mode = payload.mode;
      setTimeout(async () => {
        let category = await me.getCategory({ id: payload.id });
        if (category) {
          me.ruleForm = {
            id: category.id,
            categoryName: category.categoryName,
            cateDesc: category.cateDesc,
            status: category.status,
          };
        }
      }, 300);
    }, 300),
    async submitForm(isReset = true) {
      const me = this;
      let formEl = me.$refs.ruleFormRef;
      if (!formEl) return;
      formEl
        .validate()
        .then(async () => {
          if (me.mode == me.$enum.Mode.Edit) {
            await me.editData();
          } else {
            await me.addData(isReset);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onChangeStatus(payload) {
      const me = this;
      let status = me.statuses.find((x) => x.id == payload);
      if (status) {
        me.ruleForm.status = status.id;
      }
    },

    addMoreData: _.debounce(async function () {
      const me = this;
      await me.submitForm(false);
    }, 300),

    addData: _.debounce(async function (isReset = true) {
      const me = this;
      let result = await me.createCategory(me.ruleForm);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.AddCategorySuccess")
        );
        if (isReset == true) {
          me.ruleForm = {};
        }
      } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(result.message, "warning");
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.AddCategoryFail"),
          "warning"
        );
      }
    }, 300),

    editData: _.debounce(async function () {
      const me = this;
      let result = await me.updateCategory(me.ruleForm);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.EditCategorySuccess")
        );
        me.ruleForm = {};
      } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(result.message, "warning");
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.EditCategoryFail"),
          "warning"
        );
      }
    }, 300),

    viewDetail: _.debounce(async function (params) {
      const me = this;
      if (!params || !params.id) return;

      //lấy dữ liệu chi tiết từ API
      me.category = await me.getCategory({ id: params.id });
      if (me.category) {
        me.isShow = true;
      } else {
      }
      //Show form chi tiết
    }, 300),
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
}
</style>
